import { Button, Col, Container, Form, NavDropdown, Row, Carousel, OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useEffect, useState, useRef } from 'react';
import styles from './dashboard.module.scss';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DASHBOARD_VIEWS_WIDGET, GET_DASHBOARD_WIDGETS, SAVE_DASHBOARD_WIDGETS, GET_ANNOUNCEMENTS, GET_DASHBOARD_ANNOUNCEMENTS } from "../../../Utils/GlobalConstants";
import { api } from "../../../Utils/API";
import AddWidgets from "./LocalComponents/AddWidgets";
import MonthlySummary from "./LocalComponents/MonthlySummary";
import RecentCustomers from "./LocalComponents/RecentCustomers";
import LoginTermsAndCondition from "./LocalComponents/LoginTermsAndConditions";
import Card from "./LocalComponents/Card";
import NotificationsPopup from "./LocalComponents/NotificationsPopup";
import EmptyAnnouncement from '../../../Assets/Images/Illustrations/EmptyAnnouncement.svg';

const DashBoard = (props) => {
    // Dashboard states
    const [widgetPositionData, setWidgetPositionData] = useState([]);
    const [masterWidget, setMasterWidget] = useState([]);
    const [addWidgetPopup, setAddWidgetPopup] = useState(false);
    const [duplicatewidgetPositionData, setDuplicateWidgetPositionData] = useState([]);
    const [viewId, setViewId] = useState(null);
    const [viewData, setViewData] = useState(null);
    const [viewNameDefault, setViewNameDefault] = useState(null);
    const [noAddWidgetAvailable, setNoAddWidgetAvailable] = useState(false);
    const [announcementData, setAnnouncementData] = useState([]);
    const [announcementDataEmpty, setAnnouncementDataEmpty] = useState(false);
    const [expandedAnnouncement, setExpandedAnnouncement] = useState(null);
    const [contentHeights, setContentHeights] = useState({});
    const contentRefs = useRef({});
    const [announcementTitle, setAnnouncementTitle] = useState(null);

    const ItemTypes = {
        CARD: 'card',
    };

    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    // Function to call all dropdown values in Service Section in Filter Box
    async function GetDashboardWidget() {
        await api.get(GET_DASHBOARD_WIDGETS + "/" + viewId, config)
            .then(resp => {
                let dataWidget = [];
                if ((resp.data.widgets).length === (resp.data.master).length) {
                    setNoAddWidgetAvailable(true);
                    dataWidget = resp.data.widgets;
                }
                else {
                    setNoAddWidgetAvailable(false);
                    dataWidget = resp.data.widgets;
                    if (dataWidget.length % 2 == 0) {
                        dataWidget.push({ id: "9999", widgetName: "add" })
                        dataWidget.push({ id: "9999", widgetName: "add" })
                    }
                    else {
                        dataWidget.push({ id: "9999", widgetName: "add" })
                    }
                }
                setWidgetPositionData(dataWidget);
                setDuplicateWidgetPositionData(dataWidget);
                setMasterWidget(resp.data.master);
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    props.Logout();
                }
                else {
                }
            });
    };

    // Function to save widget in dashboard
    async function SaveDashboardWidget(widgetData, isRefreshPage) {
        let body = widgetData;
        await api.post(SAVE_DASHBOARD_WIDGETS + "/" + viewId, body, config)
            .then(resp => {
                if (isRefreshPage) {
                    setWidgetPositionData([]);
                    GetDashboardWidget();
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    props.Logout();
                }
                else {
                }
            });
    };

    async function GetAllViews() {
        await api.get(`${DASHBOARD_VIEWS_WIDGET}`, config)
            .then(resp => {
                setViewData(resp.data);
                if (viewNameDefault === null) {
                    (resp.data).map((view) => {
                        if (view.isDefaultView) {
                            setViewId(view.viewId);
                            setViewNameDefault(view.viewName);
                        }
                    })
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    props.Logout();
                }
                else {
                }
            });
    };

    async function GetAnnouncements() {
        await api.get(GET_DASHBOARD_ANNOUNCEMENTS, config)
            .then(resp => {
                if(resp.status==200){
                    setAnnouncementDataEmpty(false);
                    setAnnouncementData(resp.data.announcements);
                    setAnnouncementTitle(resp.data.titleText);
                    
                    if(resp.data.length === 0){
                        setAnnouncementDataEmpty(true);
                    }
                }
                else{
                    setAnnouncementDataEmpty(true);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                   props.Logout();
                }
                else {
                    // console.log(error);
                }
            });
    };

    // Enhanced content checking functions (from standalone component)
    const hasSpan = (content) => {
        return content && content.includes('<span');
    };

    const hasImage = (content) => {
        return content && content.includes('<img');
    };

    const isContentOnly = (content) => {
        return !hasSpan(content) && !hasImage(content);
    };

    // New function for content truncation logic
    const isContentTruncated = (content) => {
        const textLengthBasedTruncation = content.length > 450;
        return textLengthBasedTruncation;
    };

    // to show carousel controls & indicators
    const showCarouselControls = announcementData.length > 1;

    const toggleExpand = (index) => {
        if (expandedAnnouncement === index) {
            setExpandedAnnouncement(null);
        } else {
            setExpandedAnnouncement(index);
        }
    };

    const setContentRef = (index, element) => {
        contentRefs.current[`content-${index}`] = element;
    };

    const moveItem = (dragIndex, hoverIndex) => {
        const draggedItem = widgetPositionData[dragIndex];
        const newwItems = [...widgetPositionData];
        newwItems.splice(dragIndex, 1);
        newwItems.splice(hoverIndex, 0, draggedItem);
        setWidgetPositionData(newwItems);
    };

    useEffect(() => {
        GetAllViews();
        // Get Announcements data when component mounts
        GetAnnouncements();
    }, [])

    useEffect(() => {
        if (viewId) {
            GetDashboardWidget();
        }
    }, [viewId])

    useEffect(() => {
        if (widgetPositionData.length > 0 && duplicatewidgetPositionData.length > 0 && duplicatewidgetPositionData !== widgetPositionData) {
            let postDashboardPositionChange = [];
            widgetPositionData.map((widget) => {
                if (widget.widgetName !== "add") {
                    postDashboardPositionChange.push(widget);
                }
            })
            SaveDashboardWidget(postDashboardPositionChange, false);
        }
    }, [widgetPositionData])

    // Enhanced useEffect for content height checking (from standalone component)
    useEffect(() => {
        if (announcementData.length > 0) {
            setTimeout(() => {
                const heights = {};
                Object.keys(contentRefs.current).forEach(key => {
                    if (contentRefs.current[key]) {
                        heights[key] = contentRefs.current[key].scrollHeight;
                    }
                });
                setContentHeights(heights);
            }, 100);
        }
    }, [announcementData, expandedAnnouncement]);

    // Enhanced announcement section render function
    const renderAnnouncementSection = () => {
        return (
            <div className={`${styles['announcement-wrapper']}`}>
                <div className={`${styles['announcement-body-main']}`}>
                    <h3 className="mb-4 ml-3 mt-2" >{announcementTitle ? announcementTitle : "Announcements"} {!announcementDataEmpty && `(${announcementData.length})`}</h3>
                    <div className={`${styles['carousel-container']}`}>
                        {!announcementDataEmpty && announcementData && announcementData.length > 0 && 
                            <Carousel
                                className={`${styles['carousel-announcement']} ${showCarouselControls ? styles['with-controls'] : ''}`}
                                touch={showCarouselControls}
                                indicators={showCarouselControls}
                                controls={showCarouselControls}
                                interval={null}
                            >
                                {announcementData && announcementData.length > 0 && announcementData.map((data, index) => {
                                    const isExpanded = expandedAnnouncement === index;
                                    const isSpanAnnouncement = hasSpan(data.content);
                                    const isImageAnnouncement = hasImage(data.content);
                                    const isContentOnlyAnnouncement = isContentOnly(data.content);
                                    const needsReadMore = isContentTruncated(data.content);
                                    
                                    return(
                                        <Carousel.Item key={index}>
                                            <div className={`${styles['announcements-body']} ${isExpanded ? styles['expanded'] : ''}`}>
                                                {isImageAnnouncement && !isSpanAnnouncement && (
                                                    <>
                                                        {data.content && (
                                                        <div className={`${styles['announcement-content']}`}>
                                                            <div 
                                                                className={`${styles['content-container']} ${isExpanded ? styles['expanded'] : ''} ${needsReadMore && !isExpanded ? styles['needs-read-more'] : ''}`}
                                                                ref={(el) => setContentRef(index, el)}
                                                            >
                                                                <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                                                            </div>
                                                            
                                                            {needsReadMore && (
                                                                <div className={`py-2 ${styles['text-right']} ${styles['enrollment-btn-col']}`}>
                                                                    <Button
                                                                        variant="light"
                                                                        className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            toggleExpand(index);
                                                                        }}
                                                                    >
                                                                        {isExpanded ? 'Read less' : 'Read more'}
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        )}
                                                        
                                                        <Row className={`mt-3 ${styles['announcement-info-row']}`}>
                                                            {data.title && (
                                                            <Col xs={12} md={7} lg={8} className={`${styles['announcement-title-col']}`}>
                                                                <div className={`${styles['announcement-title-wrapper']}`}>
                                                                    {data.title.length > 80 ? (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={<Tooltip className={`px-2 py-1`}>{data.title}</Tooltip>}
                                                                        >
                                                                            <span>
                                                                                {data.title.slice(0, 81)}
                                                                                <span className="ml-1">. . .</span>
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    ) : (
                                                                        <>{data.title}</>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            )}
                                                            {data.link && (
                                                                <Col xs={12} md={5} lg={4} className={`mt-1 ${styles['enrollment-btn-col']}`}>
                                                                    <Button
                                                                        variant="light"
                                                                        className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                        onClick={() => window.open(data.link, '_blank')}
                                                                    >{data?.buttonLabel ? data.buttonLabel : "Enroll Now"}
                                                                    </Button>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </>
                                                )}
                                                
                                                {isSpanAnnouncement && (
                                                    <>
                                                    {data.title && (
                                                        <div className={`${styles['announcement-header']}`}>
                                                            <h1 className={`${styles['announcement-title']}`}>{data.title}</h1>
                                                        </div>
                                                    )}
                                                        {data.content && (
                                                        <div className={`${styles['announcement-content']}`}>
                                                            <div 
                                                                className={`${styles['content-container']} ${isExpanded ? styles['expanded'] : ''} ${needsReadMore && !isExpanded ? styles['needs-read-more'] : ''}`}
                                                                ref={(el) => setContentRef(index, el)}
                                                            >
                                                                <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                                                            </div>
                                                            
                                                            {needsReadMore && (
                                                                <div className={`py-2 ${styles['text-right']} ${styles['enrollment-btn-col']}`}>
                                                                    <Button
                                                                        variant="light"
                                                                        className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            toggleExpand(index);
                                                                        }}
                                                                    >
                                                                        {isExpanded ? 'Read less' : 'Read more'}
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </div>
                                                        )}
                                                    </>
                                                )}
                                                
                                                {/* For content-only announcements */}
                                                {isContentOnlyAnnouncement && (
                                                    <div className={`${styles['announcement-content']} ${styles['content-only']}`}>
                                                        <div 
                                                            className={`${styles['content-container']} ${isExpanded ? styles['expanded'] : ''} ${needsReadMore && !isExpanded ? styles['needs-read-more'] : ''}`}
                                                            ref={(el) => setContentRef(index, el)}
                                                        >
                                                            <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                                                        </div>
                                                        
                                                        {needsReadMore && (
                                                            <div className={`py-2 ${styles['text-right']} ${styles['enrollment-btn-col']}`}>
                                                                <Button
                                                                    variant="light"
                                                                    className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        toggleExpand(index);
                                                                    }}
                                                                >
                                                                    {isExpanded ? 'Read less' : 'Read more'}
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </Carousel.Item>
                                    );
                                })}
                            </Carousel>
                        }
                         {/* For no announcements screen */}
                        {announcementDataEmpty && 
                            <div className={`${styles['announcements-body']} ${styles['empty-announcements']}`}>
                                <div className={`${styles['empty-announcement-content']}`}>
                                    <img src={EmptyAnnouncement} className={`${styles['empty-announcement-svg']}`} alt="No Announcements" />
                                    <h4>No Announcements</h4>
                                    <p>We will display any new announcements here</p>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Container fluid className="main-content">
                {widgetPositionData.length > 0 && <>
                    <AddWidgets addWidgetPopup={addWidgetPopup} setAddWidgetPopup={setAddWidgetPopup} masterWidget={masterWidget} widgetPositionData={widgetPositionData} SaveDashboardWidget={SaveDashboardWidget} />
                    <Row className="align-items-center">
                        <Col md={6} lg={6} className={`${styles['top-heading-ipad-pro']}`}>
                            <h2 className="mb-0">Welcome {localStorage.getItem("profile_name")} !</h2>
                        </Col>
                        <Col md={3} lg={3} className="d-lg-block d-none"></Col>
                        <Col md={4} lg={2} xs={8}>
                            <Form.Group
                                className={`form-group col-md-12 col-lg-11 ml-3 mb-0 download-btn ${styles['left-button']}`}
                                controlId="downloadId"
                            >
                                {viewNameDefault && <NavDropdown title={viewNameDefault} id="cloud-service-dropdown"
                                    className={"servcies-dropdown"}
                                >
                                    {
                                        viewData && viewData.map((view) => {
                                            return (
                                                <NavDropdown.Item
                                                    key={view.viewId}
                                                    id={view.viewId}
                                                    value={view.viewName}
                                                    className={viewNameDefault === view.viewName ? "selected" : ""}
                                                    onClick={() => {
                                                        if (view.viewId !== viewId) {
                                                            setWidgetPositionData([]);
                                                            setDuplicateWidgetPositionData([]);
                                                            setViewNameDefault(view.viewName);
                                                            setViewId(view.viewId)
                                                        }
                                                    }}
                                                >
                                                    {view.viewName}
                                                </NavDropdown.Item>
                                            )
                                        })
                                    }
                                </NavDropdown>}
                            </Form.Group>
                        </Col>
                        <Col md={2} lg={1} xs={3} className={`${styles['button-mobile']}`}>
                            {!noAddWidgetAvailable ? 
                                <Button className={`px-2 cpointer ${styles["button-tab-view"]}`} onClick={() => { setAddWidgetPopup(true); }}>
                                    Add Widget
                                </Button> : 
                                <Button className={`btn btn-border-light btn-lg px-2 cnotallowed ${styles["button-tab-view"]}`} variant="light" disabled>
                                    Add Widget
                                </Button>
                            }
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col lg={3} md={5} className={`${styles['left-widgets-ipad-pro']}`}>
                            <RecentCustomers Logout={props.Logout} />
                            <MonthlySummary Logout={props.Logout} />
                            {/* Enhanced Announcement Container */}
                            <div className={`${styles['announcement-container']}`}>
                                {renderAnnouncementSection()}
                            </div>
                        </Col>
                        <Col lg={9} md={7} className={`${styles['right-widgets-ipad-pro']}`}>
                            <DndProvider backend={HTML5Backend}>
                                {widgetPositionData && widgetPositionData.reduce((rows, item, index) => {
                                    if (index % 2 === 0) {
                                        rows.push([]);
                                    }
                                    rows[rows.length - 1].push(
                                        <Col lg={6} md={12} key={item.id} className={`${styles['individual-widgets-ipad-pro']}`}>
                                            <Card 
                                                id={item.id} 
                                                widget={item.widgetName} 
                                                index={index} 
                                                moveItem={moveItem} 
                                                styles={styles} 
                                                SaveDashboardWidget={SaveDashboardWidget} 
                                                widgetPositionData={widgetPositionData} 
                                                useDrop={useDrop} 
                                                ItemTypes={ItemTypes} 
                                                useDrag={useDrag} 
                                                setAddWidgetPopup={setAddWidgetPopup} 
                                                Logout={props.Logout} 
                                            />
                                        </Col>
                                    );
                                    return rows;
                                }, []).map((row, rowIndex) => (
                                    <Row key={rowIndex}>
                                        {row}
                                    </Row>
                                ))}
                            </DndProvider>
                        </Col>
                    </Row>
                </>}
            </Container>
        </>
    );
}

export default DashBoard;